const Joi = require('joi')
const { jwtToken, registerPasswordField } = require('./fields')

const passwordResetSchema = Joi.object({
    token: jwtToken.required().label('Password Reset Token'),
    password: registerPasswordField.required(),
})

module.exports = passwordResetSchema